import React, { useRef, useState } from "react";
import MaskedInput from "react-text-mask";
import emailjs from "@emailjs/browser";
import "./Form.scss";

export default function App() {
    const [email, setEmail] = useState("");
    const [name, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [tel, setTel] = useState("");
    const form = useRef();

    const sendEmail = (e) => {
        e.preventDefault();

        if (window._mgq && typeof window._mgq.push === 'function') {
            window._mgq.push(["MgSensorInvoke", "Application"]);
            console.log("✅ MGID event sent: Application");
        } else {
            console.warn("❌ MGID не ініціалізований");
        }

        emailjs
            .sendForm(
                "service_dhbzbzd",
                "template_xzb0qfs",
                form.current,
                "54r806kZ5B5Q649la"
            )
            .then(
                () => {
                    alert("Ваше повідомлення відправлено успішно");
                    setEmail("");
                    setFirstName("");
                    setLastName("");
                    setTel("");
                },
                (error) => {
                    console.log(error.text);
                }
            );
    };

    return (
        <div className="form-container">
            <form
                ref={form}
                onSubmit={sendEmail}
                className="register-form"
            >
                <input
                    type="text"
                    value={name}
                    name="name"
                    placeholder="Ім'я"
                    required
                    className="form-field"
                    onChange={(e) => setFirstName(e.target.value)}
                />
                <input
                    type="text"
                    value={lastName}
                    name="lastName"
                    placeholder="Прізвище"
                    required
                    className="form-field"
                    onChange={(e) => setLastName(e.target.value)}
                />
                <input
                    className="form-field"
                    type="email"
                    value={email}
                    name="email"
                    placeholder="E-mail"
                    required
                    onChange={(e) => setEmail(e.target.value)}
                />
                <MaskedInput
                    className="form-field"
                    mask={[
                        "+", "3", "8", " ", "(", /[0-9]/, /\d/, /\d/, ")",
                        " ", /\d/, /\d/, /\d/, " ", /\d/, /\d/, " ", /\d/, /\d/
                    ]}
                    pattern="^\+[0-9]{2}\s\((\d+)\)\s\d{3}\s\d{2}\s\d{2}"
                    type="tel"
                    name="phone"
                    value={tel}
                    placeholder="Телефон"
                    required
                    onChange={(e) => setTel(e.target.value)}
                />
                <input
                    className="form-field form-field-button"
                    type="submit"
                    value="ВІДПРАВИТИ"
                />
            </form>
        </div>
    );
}
